import React from 'react';
import { Layout, SEO } from 'components/common';
import { Privacy, Footer } from 'components/theme';

export default () => (
  <Layout>
    <SEO />
    <Privacy />
    <Footer />
  </Layout>
);
